import { GroupWhatsappIcon } from '../../base';

function Whatsapp({number, show = true, color = 'pcolor', message = null}) {
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);

    function msgOnWhatsapp() {
        const phoneNumber = `+91${number}`
        const msg = message ? `text=${encodeURIComponent(message)}` : ''
        const url = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? `https://wa.me/${phoneNumber}?${msg}` : `https://web.whatsapp.com/send?phone=${phoneNumber}&${msg}`
        console.log(url)
        window.open(url, '_blank')
    }

    return (
        <div className='d-flex contactOption gap-1' style={{ alignItems : 'center'}}>
            <GroupWhatsappIcon/> :
            {
                isMobile ?
                    <div className={`option ms-1 h6 ${color}`} onClick={()=>msgOnWhatsapp()}>{number}</div> :
                    <div className={`option ms-1 h6 ${color}`} onClick={()=>msgOnWhatsapp()}>{number}</div>
            }
            {
                show && <div className='h7' onClick={()=>msgOnWhatsapp()}>(message on whatsapp)</div>
            }
        </div>
    )
}

export default Whatsapp